import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import adapter from 'garaje/utils/decorators/adapter';
// import moment from 'moment-timezone';
// import { PLAN_LEVEL, PLAN_PERIOD } from 'garaje/utils/enums';
// import { alias } from '@ember/object/computed';
// import { computed, get } from '@ember/object';

@adapter('billing-v2')
class SubscriptionModificationModel extends Model {
  @belongsTo('company', { async: true, inverse: null }) company;
  @belongsTo('billing-company', { async: true, inverse: null }) billingCompany;
  @hasMany('location-subscription', { async: false }) locationSubscriptions;
  @belongsTo('subscription-plan', { async: false }) subscriptionPlan;

  @attr('number') periodStart;

  // // Subscription Plan computeds - Do we need?
  // @alias('subscriptionPlan.app') app;
  // @alias('subscriptionPlan.name') name;
  // @alias('subscriptionPlan.level') level;
  // @alias('subscriptionPlan.rank') rank;
  // @alias('subscriptionPlan.price') price;
  // @alias('subscriptionPlan.period') period;
  // @alias('subscriptionPlan.details.unitType') unitType;
  // @alias('subscriptionPlan.pricePerPeriod') pricePerPeriod;

  // // PLAN_LEVEL computeds - Do we need?
  // @computed('level')
  // get isStandardPlan() {
  //   return this.level === PLAN_LEVEL.STANDARD;
  // }

  // @computed('level')
  // get isPremiumPlan() {
  //   return this.level === PLAN_LEVEL.PREMIUM;
  // }

  // @computed('level')
  // get isEnterprisePlan() {
  //   return this.level === PLAN_LEVEL.ENTERPRISE;
  // }

  // // PLAN_PERIOD computeds - Do we need?
  // @computed('period')
  // get isMonthly() {
  //   return this.period === PLAN_PERIOD.MONTHLY;
  // }

  // @computed('period')
  // get isYearly() {
  //   return this.period === PLAN_PERIOD.YEARLY;
  // }

  // @computed('periodStart')
  // get periodStartAt() {
  //   return moment(this.periodStart);
  // }
}

export default SubscriptionModificationModel;
